import React from 'react';

type DangerHtmlProps = {
  html: string;
  onClick?: (event: React.MouseEvent) => void;
};

const DangerHtml: React.FunctionComponent<DangerHtmlProps> = ({ html, onClick }) => {
  if (onClick) {
    return (
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      <button type="button" onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />
    );
  }

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};

export default DangerHtml;
